import React from 'react';
import { string, bool, func, shape, number, arrayOf, object } from 'prop-types';

import WishlistCard from '../WishlistCard/WishlistCard';
import { propTypes } from '../../util/types';

const DiscoverWishlistCard = props => {
  return <WishlistCard {...props} showHeartIcon={false} />;
};

DiscoverWishlistCard.defaultProps = {
  className: null,
  rootClassName: null,
  onEdit: null,
  onDelete: null,
  onShare: null,
  navigateTo: null,
};

DiscoverWishlistCard.propTypes = {
  wishlist: shape({
    id: string.isRequired,
    title: string.isRequired,
    subtitle: string,
    description: string,
    coverImageUrl: string,
    coverImageThumbnails: shape({
      mobile: string,
      tablet: string,
      desktop: string,
    }),
    items: arrayOf(object),
    isPublic: bool,
    numberOfGuests: number,
  }).isRequired,
  currentUser: propTypes.currentUser,
  className: string,
  rootClassName: string,
  onEdit: func,
  onDelete: func,
  onShare: func,
  navigateTo: string,
};

export default DiscoverWishlistCard;
